import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen grid place-items-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-md w-full text-center"
      >
        <XCircle size={48} className="text-[#E05638] mx-auto" />
        <h1 className="font-display font-bold text-3xl mt-6">Pagamento annullato</h1>
        <p className="text-neutral-600 text-sm mt-3 leading-relaxed">
          Nessun addebito è stato effettuato. Puoi riprendere la scelta del piano quando vuoi.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-home-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#111111] text-white px-7 py-3.5 text-sm font-semibold hover:bg-[#E05638] transition-colors"
        >
          <ArrowLeft size={15} /> Torna ai piani
        </Link>
      </motion.div>
    </div>
  );
}
